import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ModalContentStyled = styled.div`
  padding: 0 2rem 4rem;
`;

export const PrimaryEmailSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
  margin-bottom: 3rem;
`;

export const CcFieldsListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const CcFieldWrapperStyled = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
  margin: 0;
`;

export const ButtonStyled = styled(Button)`
  padding-top: 2.2%;
  font-weight: 700;
  text-transform: uppercase;
  min-width: 15rem;
`;

export const ListTitleStyled = styled.p`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${colors.neutral[900]};
  margin: 0;
  padding-bottom: 2rem;
`;

export const ErrorStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: ${colors.red[600]};
  margin-top: 4rem;
`;
